import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
  DUAL_PRICING_FAILURE,
  DUAL_PRICING_FIND,
  DUAL_PRICING_FIND_ALL,
  DUAL_PRICING_FIND_ALL_SUCCESS,
  DUAL_PRICING_FIND_SUCCESS,
  DUAL_PRICING_UPDATE_LOADING,
} from '@store/actions';
import { DualPricing } from '@core/models';
import { DualPricingService } from '@core/services';
import { LocalChannel } from '@core/enums';

@Injectable()
export class DualPricingEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private dualPricingService: DualPricingService
  ) {}

  // findAll$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(DUAL_PRICING_FIND_ALL),
  //     mergeMap(() => {
  //       this.store.dispatch(DUAL_PRICING_UPDATE_LOADING({  loading: true }));
  //       return this.dualPricingService.findAll().pipe(
  //         mergeMap(({ data }) => {
  //           const dualPricingList = data as DualPricing[];

  //          const dualPricing = dualPricingList.find((dualPricing) => {
  //             return dualPricing.porDefecto && !!dualPricing.canales.find((canal) => canal.nombre == LocalChannel.JuvoOlo);
  //           }) ?? null

  //           return [
  //             DUAL_PRICING_FIND_SUCCESS({ dualPricing }),
  //             DUAL_PRICING_FIND_ALL_SUCCESS({ dualPricingList }),
  //             DUAL_PRICING_UPDATE_LOADING({ loading: false }),
  //           ];
  //         }),
  //         catchError((error) => of(DUAL_PRICING_FAILURE({ error })))
  //       )
  //     }),
  //   )
  // );

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DUAL_PRICING_FIND),
      mergeMap(({id}) => {
        this.store.dispatch(DUAL_PRICING_UPDATE_LOADING({  loading: true }));
        return this.dualPricingService.find(id).pipe(
          mergeMap(({ data }) => {
            const [dualPricing] = data as DualPricing[];

            return [
              DUAL_PRICING_FIND_SUCCESS({ dualPricing }),
              DUAL_PRICING_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => of(DUAL_PRICING_FAILURE({ error })))
        )
      }),
    )
  );
}
